import React, {Component} from 'react';
import Radium from 'radium';
import Measure from 'react-measure';
import Divider from 'material-ui/Divider';
import {grey500} from 'material-ui/styles/colors';

const styles = {
  titleWrapper: {
    padding: '1em 1.5em',
  },
  title: {
    margin: 0,
  },
  subtitle : {
    color: grey500,
    fontStyle: 'italic',
    fontWeight: 'normal',
    margin: '0.3em 0 0',
  },
};

@Radium
class WidgetHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: -1,
    };
  }

  handleDimensionsChange = ({bounds, margin}) => {
    const heightWithMargin = bounds.height + margin.top + margin.bottom;
    if (this.state.height !== heightWithMargin) {
      this.setState({height: heightWithMargin});
      this.props.onHeightChange(heightWithMargin);
    }
  };

  render() {
    return (
      <div>
        <Measure bounds margin onResize={this.handleDimensionsChange}>
          {({measureRef}) =>
            <div ref={measureRef} style={styles.titleWrapper}>
              <h3 style={styles.title}>
                {this.props.title}
              </h3>
              {this.props.subtitle && (
                <h4 style={styles.subtitle}>
                  {this.props.subtitle}
                </h4>
              )}
            </div>
          }
        </Measure>
        <Divider />
      </div>
    );
  }
}

export default WidgetHeader;



// WEBPACK FOOTER //
// ./src/components/WidgetHeader/WidgetHeader.js